/**
 * The rail's icon row (fix D / R2): Home · New game · Analysis · Review (fix
 * N, 2026-10-06: "Lobby" renamed "Home"), with Tournament taking Review's
 * slot inside a tournament game.
 *
 * Chrome only — four equal tiles over a `line` hairline, no card, no borders
 * (R6.1: the rail is ONE surface and its sections are separated by hairlines).
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {SPACE} from '../../../theme/tokens';
import {useV2Theme} from '../../../theme/useV2Theme';
import {
  AnalysisAction,
  LobbyAction,
  NewGameAction,
  ReviewAction,
  TournamentAction,
} from '../tiles';
import {RailActionsModel} from './model';

export default React.memo(function RailActionsView({
  tournament,
}: RailActionsModel) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <View
      testID="v2-rail-actions"
      style={[styles.row, {boxShadow: `inset 0 -1px 0 ${tokens.line}`} as any]}>
      <LobbyAction />
      <NewGameAction />
      <AnalysisAction />
      {tournament ? <TournamentAction /> : <ReviewAction />}
    </View>
  );
});

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: SPACE.sm,
    paddingVertical: SPACE.sm,
    gap: SPACE.xs,
  },
});
